import {useTranslation} from 'react-i18next';
import logo from './ricoh-logo.png';

const RicohBanner = () => {
    const {t} = useTranslation('Layout.DualPage.RicohBanner');

    return (
        <div className="absolute right-0 h-16 rounded-lg rounded-r-none bg-white">
            <div className="relative flex h-16">
                <img alt="ricoh" className="h-16 p-5" src={logo} />
                <div className="mr-8 hidden items-center whitespace-pre text-sm font-light sm:flex">
                    {t('ricohBanner')}
                </div>
            </div>
        </div>
    );
};

export default RicohBanner;
